// extracted by mini-css-extract-plugin
module.exports = {"sectionIncome":"SectionIncome_sectionIncome_3677j"};